{{ date.day }}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-day-view.d.ts.NgbDatepickerDayView.html